/* eslint-disable max-len */
const testimonials = {
  sv: [
    {
      id: 1,
      name: 'Maria',
      text: 'Jag använde Golfamore-kortet på semestern i Spanien och det gjorde min resa oförglömlig. Halv greenfee på toppbanor – fantastiskt!'
    },
    {
      id: 2,
      name: 'Peter',
      text: 'Det handlar inte bara om besparingarna – det är variationen av banor jag fått prova. En total game-changer.'
    },
    { id: 3, name: 'David', text: 'Perfekt för golfare som jag som vill ha kvalitetsgolf utan att tömma plånboken.' },
    { id: 4, name: 'Julia', text: 'Att spela för halva priset betyder inte halva upplevelsen, många av  banorna håller toppkvalitet.' },
    { id: 5, name: 'Steve', text: 'Tack vare Golfamore kan jag spela dubbelt så mycket utan att dubbla min budget.' },
    { id: 6, name: 'Wolfgang', text: 'Efter bara två rundor hade Golfamore-kortet redan betalat sig. Självklart val för varje golfare.' }
  ],
  dk: [
    {
      id: 1,
      name: 'Maria',
      text: 'Jeg brugte Golfamore-kortet på ferie i Spanien, og det gjorde min tur uforglemmelig. Halv greenfee på topbaner – fantastisk!'
    },
    {
      id: 2,
      name: 'Peter',
      text: 'Det handler ikke kun om besparelserne – det er variationen af baner, jeg har prøvet. En total game-changer.'
    },
    { id: 3, name: 'David', text: 'Perfekt for golfspillere som mig, der vil have kvalitetsgolf uden at sprænge budgettet.' },
    { id: 4, name: 'Julia', text: 'At spille til halv pris betyder ikke en halv oplevelse – mange af banerne er i topkvalitet.' },
    { id: 5, name: 'Steve', text: 'Takket være Golfamore kan jeg spille dobbelt så meget uden at fordoble mit budget.' },
    {
      id: 6,
      name: 'Wolfgang',
      text: 'Efter bare to runder havde Golfamore-kortet allerede tjent sig ind. Et klart valg for enhver golfspiller.'
    }
  ],
  de: [
    {
      id: 1,
      name: 'Maria',
      text: 'Ich habe die Golfamore-Karte im Urlaub in Spanien benutzt, und es machte meine Reise unvergesslich. Halbes Greenfee auf Top-Plätzen – fantastisch!'
    },
    {
      id: 2,
      name: 'Peter',
      text: 'Es geht nicht nur um die Ersparnis – es ist die Vielfalt der Plätze, die ich ausprobieren konnte. Ein absoluter Game-Changer.'
    },
    { id: 3, name: 'David', text: 'Perfekt für Golfer wie mich, die Qualität wollen, ohne das Budget zu sprengen.' },
    {
      id: 4,
      name: 'Julia',
      text: 'Zum halben Preis zu spielen bedeutet nicht halbe Erfahrung – viele der Plätze sind von höchster Qualität.'
    },
    { id: 5, name: 'Steve', text: 'Dank Golfamore kann ich doppelt so viel spielen, ohne mein Budget zu verdoppeln.' },
    {
      id: 6,
      name: 'Wolfgang',
      text: 'Nach nur zwei Runden hatte sich die Golfamore-Karte schon bezahlt gemacht. Eine klare Sache für jeden Golfer.'
    }
  ],
  no: [
    {
      id: 1,
      name: 'Maria',
      text: 'Jeg brukte Golfamore-kortet på ferie i Spania, og det gjorde turen min uforglemmelig. Halv greenfee på toppbaner – fantastisk!'
    },
    {
      id: 2,
      name: 'Peter',
      text: 'Det handler ikke bare om besparelsene – det er variasjonen av baner jeg har fått prøve. En total game-changer.'
    },
    { id: 3, name: 'David', text: 'Perfekt for golfere som meg som vil ha kvalitetsgolf uten å sprenge budsjettet.' },
    { id: 4, name: 'Julia', text: 'Å spille til halv pris betyr ikke en halv opplevelse – mange av banene holder topp kvalitet.' },
    { id: 5, name: 'Steve', text: 'Takket være Golfamore kan jeg spille dobbelt så mye uten å doble budsjettet.' },
    {
      id: 6,
      name: 'Wolfgang',
      text: 'Etter bare to runder hadde Golfamore-kortet allerede betalt seg. Et selvskrevet valg for enhver golfer.'
    }
  ],
  en: [
    {
      id: 1,
      name: 'Maria',
      text: 'I used the Golfamore card on vacation in Spain, and it made my trip unforgettable. Half green fee at top courses—amazing!'
    },
    { id: 2, name: 'Peter', text: 'It’s not just the savings—it’s the variety of courses I’ve been able to try. Absolute game-changer.' },
    { id: 3, name: 'David', text: 'Perfect for golfers like me who want quality golf without breaking the bank.' },
    { id: 4, name: 'Julia', text: 'Playing half-price doesn’t mean half the experience—many of the courses are top quality.' },
    { id: 5, name: 'Steve', text: 'Thanks to Golfamore, I can play twice as much without doubling my budget.' },
    {
      id: 6,
      name: 'Wolfgang',
      text: 'After just two rounds, the Golfamore card had already paid for itself. It’s a no-brainer for any golfer.'
    }
  ]
};

export default testimonials;
// Funktion för att hämta en random kommentar från ett språk

export function getRandomTestimonial(lang) {
  const list = testimonials[lang.toLowerCase()];
  if (!list) return null;
  const randomIndex = Math.floor(Math.random() * list.length);
  return list[randomIndex];
}
